import { ServiceFetch } from '../service-fetch'

export default class ReceiptListModel extends ServiceFetch {
    getReceiptListBy = (data) => this.authFetch({
        url: 'receipt-list/getReceiptListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })


    getReceiptCopyListBy = (data) => this.authFetch({
        url: 'receipt-list/getReceiptCopyListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })


    getLastReceiptListBy = (data) => this.authFetch({
        url: 'receipt-list/getLastReceiptListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}